'use client';

import * as LucideIcons from 'lucide-react';
import type { LucideProps } from 'lucide-react';

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: string;
}

export function Icon({ name, className, size = 20, ...props }: IconProps) {
  const icons = LucideIcons as unknown as Record<string, React.ComponentType<LucideProps>>;

  // Try exact name first (BarChart2, LayoutDashboard)
  // Then try normalized version (layout-dashboard -> LayoutDashboard)
  const normalized = name.replace(/[-_\s]/g, '');
  const IconComponent = icons[name] || icons[normalized];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Lucide`);
    return null;
  }

  return <IconComponent className={className} size={size} {...props} />;
}
